import Markdown from "./Markdown";
export default Markdown;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/Markdown/index.tsx